export const ClassificationEnum = {
    lesson: 1,
    assessment:2,
    SCMSSide:3,
    project: 4,
    auxiliary: 5,
}